// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_1p","refLinkDesktop":"e_2p","titleFont":"e_3p"};